
import { App } from 'vue';
import MultiSelect from './src/index.vue';

MultiSelect.install = (app: App): void => {
    app.component(MultiSelect.name, MultiSelect);
};

export default MultiSelect;

declare module 'vue' {
    export interface GlobalComponents {
        PtMultiSelect: typeof MultiSelect;
    }
}
